import { useMemo } from 'react';
import { UpgradeDeniedModalWrapper } from './style';
import { ReactComponent as AccessBlockedIllustration } from 'assets/images/Illustration_Access_Blocked.svg';
import { Typography } from '@mui/material';
import { MainButton } from 'crono-fe-common/components/CronoButton';
import { colors } from 'crono-fe-common/theme';
import useSearchUsers from 'hooks/services/user/useSearchUsers';
import Role from 'crono-fe-common/types/enums/role';
import { fullName } from 'crono-fe-common/utils';

export interface IProps {
  onClose: () => void;
}

const UpgradeDeniedModal = ({ onClose }: IProps) => {
  const { data: usersDb, isLoading } = useSearchUsers({
    sortType: 'CreatedDate',
    userRole: Role.SUBSCRIPTION_MANAGER,
    limit: 1,
    offset: 0,
  });
  const users = usersDb?.data?.data ?? [];
  const subscriptionManager = useMemo(() => {
    if (users.length === 1) {
      const manager = users[0];
      return fullName(manager.firstName, manager.lastName);
    }

    return 'subscription manager';
  }, [users]);

  return (
    <UpgradeDeniedModalWrapper onClick={(e) => e.stopPropagation()}>
      <AccessBlockedIllustration />
      <Typography fontSize={24} fontWeight={700} lineHeight={'30px'}>
        It looks like you are not the Admin of this Subscription
      </Typography>
      {!isLoading && (
        <Typography
          fontSize={14}
          fontWeight={400}
          lineHeight={'24px'}
          color={colors.grey11}
        >
          Please ask <span className={'text-bold'}>{subscriptionManager}</span>{' '}
          to upgrade your plan to enjoy more features from Crono
        </Typography>
      )}
      <MainButton className={'close-button'} onClick={onClose}>
        Close
      </MainButton>
    </UpgradeDeniedModalWrapper>
  );
};

export default UpgradeDeniedModal;
